import styled from 'styled-components'

export const Container = styled.div`
    max-width: 1600px;
    margin: 2rem auto 5rem;
    padding: 0 20px;
    width: 100%;

    @media (max-width: 768px) {
        padding: 0 1rem;
        margin: 1rem auto 3rem;
    }
`

export const PageTitleRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2rem;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 1rem;
    }
`

export const PageTitle = styled.p`
    font-family: 'Poppins', sans-serif;
    font-weight: 700;
    margin: 0 0 1.5rem;

    font-size: 48px;

    @media (max-width: 768px) {
        font-size: 32px;
        text-align: center;
    }
`

export const SeatContainer = styled.li`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid #ddd;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
        padding: 10px 12px;
    }
`

export const SeatLabel = styled.span`
    font-weight: bold;
    flex: 1;
    min-width: 0;

    /* Optional: full width on mobile */
    @media (max-width: 768px) {
        width: 100%;
    }
`
export const PriceText = styled.div`
    font-weight: bold;
    font-size: 16px;
    margin: 0 1rem;
    white-space: nowrap;
    flex-shrink: 0;

    @media (max-width: 768px) {
        margin: 0 0.5rem;
    }
`

export const ButtonContainer = styled.div`
    display: flex;
    gap: 12px;

    @media (max-width: 768px) {
        width: 100%;
        flex-direction: column;

        button {
            width: 100%;
        }
    }
`

export const WrapperRow = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 1rem;

    @media (max-width: 768px) {
        flex-direction: column;
        justify-content: center;
        align-items: stretch;
        gap: 1rem;
        margin-top: 1rem;
    }
`

export const WrapperColumn = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`

export const TitleBox = styled.div`
    width: 100%;
    background-color: rgba(226, 232, 240, 0.9);
    margin-bottom: 2rem;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    @media (max-width: 768px) {
        justify-content: center;
        padding: 0 1rem;
    }
`

export const ShowTitle = styled.p`
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    padding: 2rem;
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 80%;
    font-size: 36px;

    @media (max-width: 768px) {
        max-width: 100%;
        font-size: 20px;
        padding: 1rem;
        white-space: normal;
        text-align: center;
    }
`

export const TicketPriceText = styled.p`
    font-weight: bold;
    font-size: 1rem;
    width: auto;
    white-space: nowrap;
`

export const TicketPrice = styled.p`
    font-weight: bold;
    font-size: 1rem;
    margin-left: 0.5rem;
    width: auto;
    white-space: nowrap;
`

export const SubSectionContainer = styled.div`
    border: 1px solid #e2e8f0;
    margin: 1rem;
    padding: 1rem;
    padding-bottom: 2rem;
    display: flex;
    flex-direction: column;
    background-color: #f5f5f5;

    @media (max-width: 768px) {
        margin: 0.5rem 0;
        padding: 1rem;
    }
`

export const HeaderRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 0.5rem;
    }
`

export const TicketInfo = styled.span`
    font-weight: bold;
    font-size: 1.1rem;

    @media (max-width: 768px) {
        font-size: 1rem;
    }
`

export const RemoveAllButton = styled.button`
    background: none;
    border: none;
    color: red;
    cursor: pointer;
    font-weight: bold;

    &:hover {
        text-decoration: underline;
    }
`

export const MessageContainer = styled.div`
    margin-top: 2rem;
    padding: 2rem;
    display: flex;
    justify-content: center;
`
